import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { PodcastAllOptionsContext } from '../context/PodcastAllOptionsContext';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Sport1 from '../assets/Sports1.png'
import Sport2 from '../assets/Sports2.png'
import Sport3 from '../assets/Sports3.png'
import Sport4 from '../assets/Sports4.png'
import { NavbarContext } from '../context/NavbarContext';
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { getAppData } from '../apiService';
import { ApiContext } from '../context/ApiContext';
import { ShimmerPostItem, ShimmerThumbnail } from 'react-shimmer-effects';


function PodcastAllOptions() {
  const { podcast } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { setRss, setImage } = useContext(ApiContext)
  const [error, setError] = useState(null);
  const { podcastId, singlePodcastId, setSinglePodcastId } = useContext(PodcastAllOptionsContext)
  const { navHeading, setNavHeading } = useContext(NavbarContext)
  const [podcasts, setPodcasts] = useState(null)
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    rows: 1,
    arrows: false,
  };
  const sliderssRef = useRef(null);
  useEffect(() => {
    setNavHeading(podcast)
  })
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const result = await getAppData(`/api.php?set=PodcastByCid&cid=${podcastId}&page=1&offset=50000`);
        if (result.success == 1) {
          // console.log(result.result.data,"categs");
          setPodcasts(result.result.data);
        } else if (result.result.totalpodcast == 0) {
          setPodcasts([])
        }
      } catch (err) {
        setError('Error fetching data. Please try again later.');
        console.error('Error:', err);
      } finally {
        setLoading(false);
      }

    };

    if (podcastId) {
      fetchData();
    } else {
      navigate("/podcast")
    }
  }, [podcastId]);

  //   const recentpodcast = [
  //         {id:"1234as",name:"SUCCESS",image:`${success}`},
  //         {id:"1234ad",name:"SPORTS",image:`${sports}`},
  //         {id:"1234af",name:"STORY",image:`${story}`},
  //         {id:"1234ag",name:"HEALTH",image:`${health}`},
  //         {id:"1234ah",name:"HEALTH",image:`${health}`},
  //         {id:"1234at",name:"SPORTS",image:`${sports}`},
  //         {id:"1234au",name:"SPORTS",image:`${sports}`},
  //     ]

  const SportsAllValue = [
    { id: "hjkllihdvhjt431", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
    // { id: "hjkllihdvhjt432", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
    // { id: "hjkllihdvhjt433", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
    // { id: "hjkllihdvhjt434", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
    // { id: "hjkllihdvhjt431", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
    // { id: "hjkllihdvhjt432", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
    // { id: "hjkllihdvhjt433", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
    // { id: "hjkllihdvhjt434", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
    // { id: "hjkllihdvhjt431", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
    // { id: "hjkllihdvhjt432", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
    // { id: "hjkllihdvhjt433", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
    // { id: "hjkllihdvhjt434", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
    // { id: "hjkllihdvhjt431", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
    // { id: "hjkllihdvhjt432", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
    // { id: "hjkllihdvhjt433", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
    // { id: "hjkllihdvhjt434", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
    // { id: "hjkllihdvhjt431", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
    // { id: "hjkllihdvhjt432", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
    // { id: "hjkllihdvhjt433", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
    // { id: "hjkllihdvhjt434", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
    // { id: "hjkllihdvhjt431", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
    // { id: "hjkllihdvhjt432", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
    // { id: "hjkllihdvhjt433", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
    // { id: "hjkllihdvhjt434", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
    // { id: "hjkllihdvhjt431", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
    // { id: "hjkllihdvhjt432", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
    // { id: "hjkllihdvhjt433", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
    // { id: "hjkllihdvhjt434", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },

  ]

  const handleClick = (rss, imgs) => {
    setRss(rss);
    setImage(imgs)
    navigate(`/player`)
  }

  if (loading) {
    return (
      <div className="layout-div1">
        <div style={{ height: "100vh" }}>
          <div className='slider-container44'>
            <div style={{ display: "flex" }} className='albums-shimmer-post-items'>

              {/* <ShimmerPostItem card text imageType="thumbnail" style={{marginTop:"30px !important"}} />
                        <ShimmerPostItem card text imageType="thumbnail" style={{marginTop:"0px"}} />
                        <ShimmerPostItem card text imageType="thumbnail" style={{marginTop:"0px"}} />
                        <ShimmerPostItem card text imageType="thumbnail" style={{marginTop:"0px"}} />
                        <ShimmerPostItem card text imageType="thumbnail" style={{marginTop:"0px"}} />
                        <ShimmerPostItem card text imageType="thumbnail" style={{marginTop:"0px"}} /> */}

              <ShimmerThumbnail width={200} /><ShimmerThumbnail width={200} /><ShimmerThumbnail width={200} /><ShimmerThumbnail width={200} /><ShimmerThumbnail width={200} />



            </div>
          </div>
          <div className='podcast-all-options-main'>
            <ShimmerThumbnail width={142} /><ShimmerThumbnail width={142} /><ShimmerThumbnail width={142} /><ShimmerThumbnail width={142} /><ShimmerThumbnail width={142} />
          </div>

        </div>
      </div>
    );
  }

  if (error) {
    return (
      <>
        <div className="blur-background"></div>
        <div className="error-container">
          <p>{error}</p>
        </div>
      </>
    )
  }

  return (
    <div className='layout-div1'>
      {/* podcast:{podcast}
        id: {podcastId} */}
      <div className='podcast-all-options-main'>
        {podcasts.map((item) => (
          <div className='podcast-all-options-single-main' key={item.id} onClick={() => handleClick(item.rss_feed, encodeURI(item.image))}>
            <div className='podcast-all-options-image'>
              <img src={item.image} alt={item.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            </div>
            <div className='podcast-all-options-text'>
              <p className='podcast-all-options-heading'>{item.title}</p>
              {/* <p className='podcast-all-options-timing'>{item.time}</p> */}
            </div>
          </div>
        ))}
      </div>
      <div style={{ height: "100vh" }}>
        {podcasts.length === 0 ? (
          <p style={{ paddingTop: "40px" }}>{navHeading} category is empty.</p>
        ) : (
          <div className="slider-container44">
            <div className="slider-wrapper44">
              <Slider ref={sliderssRef} {...settings}>
                {podcasts.map((item) => (

                  <div key={item.id} className="slide-item" onClick={() => handleClick(item.rss_feed, encodeURI(item.image))}>
                    <div className="slider-d-jhu44">
                      <div className="podcast-hjgwqjht44">
                        <img src={item.image} alt={`Slide ${item.image}`} style={{ width: "100%", height: "100%" }} />
                      </div>
                      <p className='podcast-para-ytr44'>{item.title}</p>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>

            <button className="slider-arrow44 right44" onClick={() => sliderssRef.current.slickNext()}>
              <span style={{ marginRight: "5px" }}>More...</span><MdOutlineKeyboardDoubleArrowRight />
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default PodcastAllOptions